module.exports = __webpack_public_path__ + "static/assets/d2a1e227db73b35f97bcc7de7137d84b.svg";